import { render } from "./mobile-footer-navigation.vue?vue&type=template&id=53cde790"
import script from "./mobile-footer-navigation.vue?vue&type=script&lang=js"
export * from "./mobile-footer-navigation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak/.worktrees/pdp-golive-uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__